import { types } from '@coconut/services/redux/questionListTutorial';
import { save } from '@coconut/utils/localQuestionListTutorial';

const tutorialSyncWithLocalStorageMiddleware =
  (store) => (next) => (action) => {
    // result after action has dispatched.
    const result = next(action);

    const isTutorialAction = Object.keys(types).includes(action.type);

    if (isTutorialAction) {
      save(store.getState().questionListTutorial);
    }

    return result;
  };

export default tutorialSyncWithLocalStorageMiddleware;



// WEBPACK FOOTER //
// ./src/store/tutorialSyncWithLocalStorageMiddleware.js